import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shared.service';
@Component({
  selector: 'app-employee-view-request',
  templateUrl: './employee-view-request.component.html',
  styleUrls: ['./employee-view-request.component.scss']
})
export class EmployeeViewRequestComponent implements OnInit {
  constructor(private service: SharedService) { }
  requestList: any = [];
  employeeList: any = [];
  pendingList: any = [];
  acceptedList: any = [];
  rejectedList: any = [];
  empId: number = 196;
  employee: any;
  ngOnInit(): void {
    this.service.currentEmployee.subscribe(data => {
      this.employee = data
      this.empId = this.employee.pkEmpId;
      this.RefreshRequestList();
    });
  }
  Test() {
    console.log(this.requestList);
  }
  GetEmployee(id: number) {
    this.employee = this.employeeList.find((emp: { pkEmpId: number; }) => emp.pkEmpId === id);
  }
  GetEmployeeList() {
    this.service.GetEmpList().toPromise().then(data => {
      this.employeeList = data;
      this.GetEmployee(this.empId);
    });
  }
  RefreshRequestList() {
    this.service.GetEmployeeRequests(this.empId).toPromise().then(data => {
      this.requestList = data;
      this.SplitRequestList();
    });
  }
  SplitRequestList() {
    for (var request of this.requestList) {
      if (request.Status == 'Pending') {
        this.pendingList.push(request);
      }
      else if (request.Status == 'Accepted') {
        this.acceptedList.push(request);
      }
      else if (request.Status == 'Rejected') {
        this.rejectedList.push(request);
      }
    }
  }
  GetAdminName(request: any) {
    var admin = this.employeeList.find((emp: { pkEmpId: number; }) => emp.pkEmpId === request.fkAdminId)
    var name = admin?.FirstName + ' ' + admin?.LastName;
    return name
  }
}